var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BoutiqueProduit } from 'boutique/classes/BoutiqueProduit.class';
import axiosInstance from '../../store/AxiosSingleton';
import { BoutiqueCommande } from 'boutique/classes/BoutiqueCommande.class';
import { BoutiqueModeReglement } from 'boutique/classes/BoutiqueModeReglement.class';
import { BoutiqueFacture } from 'boutique/classes/BoutiqueFacture.class';
export class BoutiqueService {
    /**
     * Récupère les produits par catégorie
     * @param idCategorie Identifiant de la catégorie
     * @return La liste des produits de la catégorie
     */
    static loadProduits(idCategorie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'LOAD_PRODUITS',
                    idCategorie,
                },
            });
            return content.map((produit) => new BoutiqueProduit(produit));
        });
    }
    /**
     * Récupère les moyens de paiements
     * @returns Les moyens de paiements
     */
    static loadMoyenPaiements() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'LOAD_MOYEN_PAIEMENT',
                },
            });
            return content.map((reglement) => new BoutiqueModeReglement(reglement));
        });
    }
    /**
     * Récupère la commande d'un membre
     * @param idMembre Identifiant du membre
     * @return La commande
     */
    static loadCurrentCommande(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'CURRENT_COMMANDE',
                    idMembre,
                },
            });
            return content == null ? null : new BoutiqueCommande(content);
        });
    }
    /**
     * Récupère une commande
     * @param idCommande Identifiant de la commande
     * @return La commande
     */
    static loadCommandeById(idCommande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'LOAD_COMMANDE_BY_ID',
                    idCommande,
                },
            });
            return content == null ? null : new BoutiqueCommande(content);
        });
    }
    /**
     * Enregistre une commande
     * @param commande La commande
     * @return La commande enregistré
     */
    static saveCommande(commande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                commande: commande.toRaw(),
            }, {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'SAVE_COMMANDE',
                },
            });
            return content === null ? null : new BoutiqueCommande(content);
        });
    }
    /**
     * Ajoute un produit à la commande de l'utilisateur
     * @param data Les données du produit et de la commande
     * @return La commande enregistré
     */
    static addProduit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                produit: data.produit.toRaw(data.caracteristique),
                idCommande: data.idCommande,
            }, {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'ADD_PRODUIT',
                },
            });
            return new BoutiqueCommande(content);
        });
    }
    /**
     * Retire un produit à la commande de l'utilisateur
     * @param data Les données du produit et de la commande
     * @return La commande
     */
    static removeProduit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'REMOVE_PRODUIT',
                    idCommande: data.idCommande,
                    idProduitCaracteristique: data.idProduitCaracteristique,
                },
            });
            return content === null ? null : new BoutiqueCommande(content);
        });
    }
    /**
     * Sauvegarde le moyen de paiement de la commande
     * @param commande La commande
     * @return La commande et les informations Stripe
     */
    static saveMoyenPaiement(commande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { commande: commande.toRaw() }, {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'SAVE_MOYEN_PAIEMENT',
                },
            });
            return {
                commande: new BoutiqueCommande(content.commande),
                cs: content.cs,
            };
        });
    }
    /**
     * Récupère l'intention de paiement
     * @param commande La commande
     * @returns L'identifiant de l'intention de paiement de la commande
     */
    static getPaiementIntent(commande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { commande: commande.toRaw() }, {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'GET_PAIEMENT_INTENT',
                },
            });
            return content;
        });
    }
    /**
     * Vérifie le paiement d'une commande
     * @param commande La commande
     * @returns La commande
     */
    static checkPaiement(commande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { commande: commande.toRaw() }, {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'CHECK_PAIEMENT',
                },
            });
            return new BoutiqueCommande(content);
        });
    }
    /**
     * Récupère une facture
     * @param idCommande L'identifiant de la commande
     * @returns La facture
     */
    static getFacture(idCommande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'GET_FACTURE',
                    idCommande,
                },
            });
            return new BoutiqueFacture(content);
        });
    }
    /**
     * Récupère les factures d'un membre
     * @param idMembre Identifiant du membre
     * @return Les commandes d'un membre
     */
    static loadFactures(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'LOAD_FACTURES',
                    idMembre: params.idMembre,
                    order: params.orderBy,
                    page: params.page,
                },
            });
            return content.map((commande) => new BoutiqueCommande(commande));
        });
    }
    /**
     * Récupère les filtres de facture membre
     * @param idMembre Identifiant du membre
     * @return Les filtres de factures du membre
     */
    static loadFacturesFiltres(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'LOAD_FACTURES_FILTRES',
                    idMembre,
                },
            });
            return content;
        });
    }
    /**
     * Ajoute la date de paiement
     * @param idCommande Identifiant de la commande
     * @returns True si action réussie
     */
    static addPaymentDate(idCommande) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: BoutiqueService.rubModule,
                    action: 'ADD_PAYMENT_DATE',
                    idCommande,
                },
            });
            return content;
        });
    }
}
BoutiqueService.rubModule = 'boutique';
//# sourceMappingURL=data:application/json;base64,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